import { Flex, Form, Spin } from "@/base/components/index";
import { DrawerForm } from "@/composites/drawer-form/index";
import { DeploymentSubscriptionAssignDataType } from "@/schemas/index";
import { useMemo } from "react";
import { useContextModalHardwareInstall } from "../context/modal-hardware-install-context";
import { ModalHardwareInstallBusinessUnitCreate } from "./modal-hardware-install-business-unit-create";
import { ModalHardwareInstallBusinessUnitSelect } from "./modal-hardware-install-business-unit-select";
import { ModalHardwareInstallCRBrandSelect } from "./modal-hardware-install-cr-brand-select";
import { ModalHardwareInstallDescription } from "./modal-hardware-install-description";
import { MModalHardwareInstallFinish } from "./modal-hardware-install-finish";
import { ModalHardwareInstallFooter } from "./modal-hardware-install-footer";
import { useModalHardwareInstallStyles } from "./modal-hardware-install.styles";

const defaultInitialValues: DeploymentSubscriptionAssignDataType = {
  NewBusinessUnit: false,
  Id: undefined,
  ProductId: undefined,
  ProductNumber: undefined,
  BusinessUnitIds: [],
  BusinessUnitAccountId: undefined,
  BusinessUnitProductId: undefined,
  BusinessUnitFuelBrandId: undefined,
  BusinessUnitName: undefined,
  BusinessUnitPhoneNumber: undefined,
  BusinessUnitAddressLine1: undefined,
  BusinessUnitAddressCity: undefined,
  BusinessUnitAddressPostalCode: undefined,
  BusinessUnitAddressStateOrProvince: undefined,
  CashRegisterBrandId: undefined,
  CashRegisterModelId: undefined,
  VendorIds: [],
};

export const ModalHardwareInstall = () => {
  const { styles } = useModalHardwareInstallStyles();
  const {
    isOpenDrawer,
    hardwareItem,
    close,
    form,
    currentPageId,
    fetchSubmitHardwareInstall,
    deploymentData,
  } = useContextModalHardwareInstall();

  const handleFinish = () => {
    const values = form.getFieldsValue(true);

    fetchSubmitHardwareInstall({
      ...values,
      PurchasedProductId: hardwareItem!.PurchasedProductId,
      ProductId: hardwareItem!.ProductId,
      ProductNumber: hardwareItem!.ProductNumber,
    });
  };

  const validateMessages = {
    required: "",
  };

  const initialValues = useMemo(() => {
    const initialValues = {
      ...defaultInitialValues,
      BusinessUnitIds:
        deploymentData?.BusinessUnits?.filter(
          (businessUnit) => businessUnit.ValidationSameProduct,
        ).map((businessUnit) => businessUnit.Id) ||
        defaultInitialValues.BusinessUnitIds,
    };
    if (isOpenDrawer) {
      form.setFieldsValue(initialValues);
    }
    return initialValues;
  }, [deploymentData?.BusinessUnits, isOpenDrawer]);

  return (
    <DrawerForm
      open={isOpenDrawer || false}
      onClose={close}
      title={<ModalHardwareInstallDescription />}
      footer={<ModalHardwareInstallFooter />}
      className={styles.drawer}
      destroyOnHidden={true}
    >
      <Form
        size="large"
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={initialValues}
        validateMessages={validateMessages}
      >
        {currentPageId === "loading" && (
          <Flex justify="center" align="center" className={styles.loader}>
            <Spin size="large" />
          </Flex>
        )}

        <Flex vertical gap={24}>
          {currentPageId === "business-unit-select" && (
            <ModalHardwareInstallBusinessUnitSelect />
          )}
          {currentPageId === "business-unit-create" && (
            <ModalHardwareInstallBusinessUnitCreate />
          )}
          {currentPageId === "cr-select" && (
            <ModalHardwareInstallCRBrandSelect />
          )}
          {currentPageId === "finish" && <MModalHardwareInstallFinish />}
        </Flex>
      </Form>
    </DrawerForm>
  );
};
